import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionCreators from "../../action/index.js";
import Slider from "react-slick";
class TermsInfo extends Component {
  render() {
    return (
      <>
        <div className="terms-conditon-wrapper-info highlight-with-bg">
          {this.props.const_var.estimator_disclaimer != null ? (
            <>
              <p>{this.props.const_var.estimator_disclaimer}</p>
            </>
          ) : (
            <>
              <p className="">
                Colors on screen may differ slightly from actual colors.
              </p>

              <p>
                Prices may change due to regional permits and
                certifications.
              </p>

              <p>
                3D building designs are representational only, not
                engineered drawings.
              </p>

              <p>Truss designs may differ by region.</p>

              <p>
                Custom garage doors are special order items, incurring extra
                cost and lead time.
              </p>

              {
                this.props?.params?.m_s_n == 153 &&
                  <p>The certification package is only available to the following: <br/> - 3/12 Roof Pitch (Lean-To's as well) <br/>- Buildings 12' Tall & Under<br/>- Buildings 30' Wide and Under</p>
              }
              
              {
                this.props.const_var.crmSetting.api_token != undefined && this.props.const_var.crmSetting.api_token == "GtkyWvtJE6mvNbtk4wEWHWZNeq9HGcudwHdcd9zledoPP4l7lXn3OFeagwGoDbtT" && 
                <>
                  <p>
                    12 gauge upgrade are on posts and truss only.
                  </p>
                  <p>
                    Interior panels only come 7ft tall, vertical orientation, and only in the color of bright white.
                  </p>
                </>
              }
            </>
          )}

          {/* <h6>Heading</h6> */}
        </div>
      </>
    );
  }
}
const mapStoreToProps = (state) => {
  return state.reducer;
};
export default connect(mapStoreToProps, actionCreators)(TermsInfo);
